export const CONSOLE_RECOVERY_PATH = '/password-recovery'

/**
 * A failed GoTrue link does not necessarily retain `type=recovery`, so the
 * dedicated landing path is part of the custody proof. An OAuth/magic-link
 * fragment on that path is still not a password grant.
 */
export function isConsoleRecoveryArrival(
  location: Pick<Location, 'pathname' | 'hash'> | undefined =
    typeof window === 'undefined' ? undefined : window.location,
): boolean {
  if (location?.pathname !== CONSOLE_RECOVERY_PATH || location.hash.length < 2) return false
  const params = new URLSearchParams(location.hash.slice(1))
  return params.get('type') === 'recovery'
    || Boolean(params.get('error_code') ?? params.get('error'))
}

/** The caller cannot supply this destination; it is always this console. */
export function consoleRecoveryUrl(
  location: Pick<Location, 'origin'> | undefined =
    typeof window === 'undefined' ? undefined : window.location,
): string | undefined {
  return location ? new URL(CONSOLE_RECOVERY_PATH, location.origin).toString() : undefined
}
